export const favouritesConstants = {
  GET_FAVOURITES_LIST_REQUEST: "GET_FAVOURITES_LIST_REQUEST",
  GET_FAVOURITES_LIST_COMPLETE: "GET_FAVOURITES_LIST_COMPLETE",
  GET_FAVOURITES_LIST_ERROR: "GET_FAVOURITES_LIST_ERROR",

  GET_RECENT_FAVOURITES_LIST_REQUEST: "GET_RECENT_FAVOURITES_LIST_REQUEST",
  GET_RECENT_FAVOURITES_LIST_COMPLETE: "GET_RECENT_FAVOURITES_LIST_COMPLETE",
  GET_RECENT_FAVOURITES_LIST_ERROR: "GET_RECENT_FAVOURITES_LIST_ERROR",

  ADD_TO_FAVOURITES_REQUEST: "ADD_TO_FAVOURITES_REQUEST",
  ADD_TO_FAVOURITES_COMPLETE: "ADD_TO_FAVOURITES_COMPLETE",
  ADD_TO_FAVOURITES_ERROR: "ADD_TO_FAVOURITES_ERROR",

  SET_SELECTED_FAVOURITE: "SET_SELECTED_FAVOURITE",
  SET_SELECTED_PATH_NAME: "SET_SELECTED_PATH_NAME",
  CLEAR_ADD_TO_FAVOURITE_CONFIRMATION: "CLEAR_ADD_TO_FAVOURITE_CONFIRMATION",

  SET_IS_PAGINATING_FAVOURITES: "SET_IS_PAGINATING_FAVOURITES",

  TRANSACTION_TYPE_ALL: "ALL",
  TRANSACTION_TYPE_BILLER: "BILLER",
  TRANSACTION_TYPE_TRANSFER: "TRANSFER",

  SET_FAVOURITES_ACTIVE_TAB: "SET_FAVOURITES_ACTIVE_TAB",

  FORM_TAB_TYPE_PAY: "PAY",
  FORM_TAB_TYPE_ACTIVITY: "ACTIVITY",
  FORM_TAB_TYPE_DETAILS: "DETAILS",

  SET_FAVOURITE_SCREEN_TYPE: "SET_FAVOURITE_SCREEN_TYPE",
  SET_FORM_TAB_TYPE: "SET_FORM_TAB_TYPE",

  SET_OTP_CONFIRNATION_STATUS: "SET_OTP_CONFIRNATION_STATUS",

  SET_FAVOURITE_SELECTED_PAYMENT_OPTION:
    "SET_FAVOURITE_SELECTED_PAYMENT_OPTION",

  FAVOURITES_PAYABLE_LIST_REQUEST: "FAVOURITES_PAYABLE_LIST_REQUEST",
  FAVOURITES_PAYABLE_LIST_COMPLETE: "FAVOURITES_PAYABLE_LIST_COMPLETE",
  FAVOURITES_PAYABLE_LIST_ERROR: "FAVOURITES_PAYABLE_LIST_ERROR",

  SET_FAVOURITE_PAYABE_ACCOUNTS: "SET_FAVOURITE_PAYABE_ACCOUNTS",

  SET_FAVOURITE_PAYABE_CARDS: "SET_FAVOURITE_PAYABE_CARDS",
  SET_FAVOURITE_AMOUNT: "SET_FAVOURITE_AMOUNT",
  SET_FAVOURITE_OUTSTANDING_AMOUNT: "SET_FAVOURITE_OUTSTANDING_AMOUNT",
  SET_FAVOURITE_PAY_ACCOUNT_NUMBER: "SET_FAVOURITE_PAY_ACCOUNT_NUMBER",
  SET_FAVOURITE_CARD_TYPE: "SET_FAVOURITE_CARD_TYPE",
  SET_FAVOURITE_PAY_BALANCE: "SET_FAVOURITE_PAY_BALANCE",
  SET_FAVOURITE_PAYMENT_STATUS: "SET_FAVOURITE_PAYMENT_STATUS",

  VALIDATE_FAVOURITE_AMOUNT_REQUEST: "VALIDATE_FAVOURITE_AMOUNT_REQUEST",
  VALIDATE_FAVOURITE_AMOUNT_ERROR: "VALIDATE_FAVOURITE_AMOUNT_ERROR",
  VALIDATE_FAVOURITE_AMOUNT_COMPLETE: "VALIDATE_FAVOURITE_AMOUNT_COMPLETE",

  UPDATE_FAVOURITE_REQUEST: "UPDATE_FAVOURITE_REQUEST",
  UPDATE_FAVOURITE_ERROR: "UPDATE_FAVOURITE_ERROR",
  UPDATE_FAVOURITE_COMPLETE: "UPDATE_FAVOURITE_COMPLETE",

  DELETE_FAVOURITE_REQUEST: "DELETE_FAVOURITE_REQUEST",
  DELETE_FAVOURITE_ERROR: "DELETE_FAVOURITE_ERROR",
  DELETE_FAVOURITE_COMPLETE: "DELETE_FAVOURITE_COMPLETE",

  CLEAR_FAVOURITE: "CLEAR_FAVOURITE",
  CLEAR_FAVOURITE_ACTIVE_TAB: "CLEAR_FAVOURITE_ACTIVE_TAB",

  FAVOURITE_PAY_BILL_REQUEST: "FAVOURITE_PAY_BILL_REQUEST",
  FAVOURITE_PAY_BILL_COMPLETE: "FAVOURITE_PAY_BILL_COMPLETE",
  FAVOURITE_PAY_BILL_ERROR: "FAVOURITE_PAY_BILL_ERROR",

  FAVOURITE_OUTSTANDING_AMOUNT_REQUEST: "FAVOURITE_OUTSTANDING_AMOUNT_REQUEST",
  FAVOURITE_OUTSTANDING_AMOUNT_COMPLETE:
    "FAVOURITE_OUTSTANDING_AMOUNT_COMPLETE",
  FAVOURITE_OUTSTANDING_AMOUNT_ERROR: "FAVOURITE_OUTSTANDING_AMOUNT_ERROR",

  FAVOURITE_DETAILS_REQUEST: "FAVOURITE_DETAILS_REQUEST",
  FAVOURITE_DETAILS_COMPLETE: "FAVOURITE_DETAILS_COMPLETE",
  FAVOURITE_DETAILS_ERROR: "FAVOURITE_DETAILS_ERROR",

  TRY_AGAIN_FAVOURITE_PAYMENT: "TRY_AGAIN_FAVOURITE_PAYMENT",
  FAVOURITE_SUCCESS_TYPE: "SUCCESS",
  FAVOURITE_PENDING_TYPE: "PENDING",
  FAVOURITE_FAILED_TYPE: "FAILED",

  CLEAR_FAVOURITE_AMOUNT_VALIDATION_STATUS:
    "CLEAR_FAVOURITE_AMOUNT_VALIDATION_STATUS",

  FAVOURITE_OTP_CONFIRMATION_REQUEST: "FAVOURITE_OTP_CONFIRMATION_REQUEST",
  FAVOURITE_OTP_CONFIRMATION_COMPLETE: "FAVOURITE_OTP_CONFIRMATION_COMPLETE",
  FAVOURITE_OTP_CONFIRMATION_ERROR: "FAVOURITE_OTP_CONFIRMATION_ERROR",

  FAVOURITE_TRANSACTION_HISTORY_LIST_REQUEST:
    "FAVOURITE_TRANSACTION_HISTORY_LIST_REQUEST",
  FAVOURITE_TRANSACTION_HISTORY_LIST_COMPLETE:
    "FAVOURITE_TRANSACTION_HISTORY_LIST_COMPLETE",
  FAVOURITE_TRANSACTION_HISTORY_DETAIL_REQUEST:
    "FAVOURITE_TRANSACTION_HISTORY_DETAIL_REQUEST",

  FAVOURITE_TRANSACTION_HISTORY_DETAIL_COMPLETE:
    "FAVOURITE_TRANSACTION_HISTORY_DETAIL_COMPLETE",

  FAVOURITE_OTP_RESEND_REQUEST: "FAVOURITE_OTP_RESEND_REQUEST",
  FAVOURITE_OTP_RESEND_COMPLETE: "FAVOURITE_OTP_RESEND_COMPLETE",
  FAVOURITE_OTP_RESEND_ERROR: "FAVOURITE_OTP_RESEND_ERROR",

  CLEAR_FAVOURITE_LIST: "CLEAR_FAVOURITE_LIST",
};
